import React from "react";
import { Outlet } from "react-router-dom";

import Header from "./Header";
import FooterInfoComponent from "./FooterInfoComponent";

//* Layout -> for all pages
const Layout = (): JSX.Element => {
  return (
    <React.Fragment>
      <Header />
      <div className="global-container">
        <Outlet />
      </div>
      <FooterInfoComponent />
    </React.Fragment>
  );
};

export default Layout;
